import { AsyncModule } from 'vuex-async-mutations';

import BaseDetails from '@/store/modules/base.details';
import BaseItemsPaginated from '@/store/modules/base.items.paginated';
import { Project } from '@/types';

export const module = {
  namespaced: true,

  async: true,

  modules: {
    details: BaseDetails<Project>('/projects', 'id'),
    items: BaseItemsPaginated<Project>('/projects', 'id'),
    houses: {
      namespaced: true,
      async: true,
      module: {
        details: BaseDetails<Project>('/projects/houses', 'id'),
        items: BaseItemsPaginated<Project>(id => ({ endpoint: `/projects/${id}/houses` }), 'id'),
      },
    },
  },
} as AsyncModule<any, any>;

export default module;
